import memoize from 'lodash/memoize'
import {
  makeGetSession,
  makeFetchAnswer,
  makeGetRawHistory,
  makeGetHistory,
  makeGetBotResponse,
  makeGetConversationId,
  getSessionData,
  setSessionData
} from './shared'

const botapiAdapter = config => {
  const { botId, botName, apiUrl, userId, user_email, app_instance_id, call_session_id } = config
  // Relevant in windowed mode
  if (user_email && app_instance_id ) {
    localStorage.setItem('user_email', user_email)
    sessionStorage.setItem('app_instance_id', app_instance_id)
    sessionStorage.setItem('call_session_id', call_session_id)
  }
  const botUrl = apiUrl || process.env.REACT_APP_BOT_URL
  sessionStorage.setItem('bot_name', botName || botId)
  sessionStorage.setItem('bot_id', botId)

  const sessionUrl = `${botUrl}/session`
  const historyUrl = `${botUrl}/history`
  const conversationIdUrl = `${botUrl}/conversation-id`

  const getSession = memoize(
    makeGetSession({ sessionUrl, userId, getSessionData, setSessionData, botId })
  )
  const fetchAnswer = makeFetchAnswer({ botId, botUrl, getSession })
  const getRawHistory = makeGetRawHistory({ getSession, historyUrl })
  const getHistory = makeGetHistory({ getRawHistory })
  const getBotResponse = makeGetBotResponse({ fetchAnswer })
  const getConversationId = makeGetConversationId({ getSession, conversationIdUrl })

  return {
    getBotResponse,
    getHistory,
    getConversationId
  }
}
export default botapiAdapter



// WEBPACK FOOTER //
// ./src/App/services/adapters/botapi/index.js